export default __webpack_public_path__ + "static/media/not_found_scan_icon.8b0af940.svg";